import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faMapMarkerAlt, faSearch, faEdit, faFileAlt, faCheck, faSave, faFileSignature, faFile, faEye } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import MainCard from 'components/MainCard/MainCard';

//Components
import Loading from '../../../../components/Loading/Loading';
import TabelaEnderecos from './TabelaEnderecos';
import ModalCustomized from 'components/Modal/Modal';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';
import TextField from 'components/TextField/TextField';
import FichaPGRS from '../../../../views/PGRS/FichaPGRS';

//Helpers
import mascaras from '../../../../helpers/mascaras';
import { showMessage } from 'helpers/message';
import { abrirPDF } from '../../../../helpers/abrirPDF';
import { showQuestion } from 'helpers/message';

//API
import gerador_api from '../../../../api/gerador_api';
import usuario_api from '../../../../api/usuario_api';
import modalidadeColeta_api from '../../../../api/modalidadeColeta_api';
import transportador_api from '../../../../api/transportador_api';

//Context
import { useAuth } from "../../../../context/auth";
import { useDashboard } from '../../../../context/DashboardContext';
import acesso_api from 'api/acesso_api';


import { actionsTable } from '../../../../constants/MaterialTable';

export default function AnaliseGeradorLocalidade({ btnVoltar, geradorSelecionado }) {
    const { session, setupVariavel } = useAuth();
    const { setDadosDashboardProvider } = useDashboard();

    const [openModalTransportador, setOpenModalTransportador] = useState(false);
    const [rowDataAprovacao, setRowDataAprovacao] = useState(null);
    const [optionsModalidades, setOptionsModalidades] = useState([]);
    const [optionsTransportadores, setOptionsTransportadores] = useState([]);
    const [modalidadeSelecionada, setModalidadeSelecionada] = useState(null);
    const [transportadorSelecionado, setTransportadorSelecionado] = useState(null);
    const [carregandoTransportadores, setCarregandoTransportadores] = useState(false);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos dados do gerador
    const [gerador, setGerador] = useState(geradorSelecionado);

    //Estado que guarda os campos que estão incorretos
    const [errors, setErrors] = useState({});

    //Estado de controle de exibição do modal de recusa de recebimento de residuos
    const [openModalRecusa, setOpenModalRecusa] = useState(false);

    // Armazena o texto da justificativa da reprovação
    const [justificativaReprova, setJustificativaReprova] = useState("")

    // Armazena os dados da linha para aprovação/recusa
    const [rowDataRecusa, setRowDataRecusa] = useState(null);

    //Estado para guarda os pgrs(s) referente ao endereço
    const [listaPGRSEndereco, setListaPGRSEndereco] = useState([]);

    //Estado para pegar o pgrs da lista referente ao endereço
    const [itemSelecionandoPGRS, setItemSelecionandoPGRS] = useState(null);
    //Estado que controla a visibilidade do modal
    const [isOpenModalPGRS, setIsOpenModalPGRS] = useState(false);

    const toggleModalPGRS = () => setIsOpenModalPGRS(!isOpenModalPGRS);


    const [visualizarModalAnalise, setVisualizarModalAnalise] = useState(0)
    const [fichaAnaliseLocalidade, setFichaAnaliseLocalidade] = useState()
    //Cabeçalhos da tabela de listagem de ações 
    const headersTabela = [
        { value: "Data/Hora", objectValue: "dataHora", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Observações", objectValue: "observacoes", align: "left" },
        { value: "Usuário Aprovação", objectValue: "nomeUsuario", align: "left" },
    ];

    //Controle de exibição do modal de recusa na tela
    const toggleModalRecusa = () => {
        setOpenModalRecusa(!openModalRecusa);
    };

    //Controle de exibição do modal de recusa na tela
    const toggleModalFicaAnalise = () => {
        setVisualizarModalAnalise(!visualizarModalAnalise);
    };

    //Função para aprovar ou reprovar uma localidade
    function analisarLocalidade(rowData) {

        if (rowData.status === "Ativo" && setupVariavel?.informarTransportadorAprovacaoCadastro) {
            setRowDataAprovacao(rowData);
            setOpenModalTransportador(true);
        }
        else if (rowData.status == "Ativo") {
            showQuestion("Aviso",
                `Tem certeza que deseja aprovar essa localidade?`,
                "info", (confirmation) => analisarLocalidadeConfirmation(confirmation, rowData));
        }
        else {
            setRowDataRecusa(rowData)
            setOpenModalRecusa(true)
        }
    }

    // Função de validação para verificar se a justificativa está preenchida
    const validarJustificativa = () => {
        const _errors = {};
        if (!justificativaReprova.trim()) {
            _errors.justificativaReprova = "";
        }
        return _errors;
    };

    async function analisarLocalidadeConfirmation(confirmation, rowData) {
        if (confirmation) {
            // Valida justificativa
            const _errors = validarJustificativa();
            setErrors(_errors);
            if (Object.keys(_errors).length > 0 && rowData.status !== "Ativo") return;

            let analiseLocalidade = {
                tbGeradorLocalidades_Id: rowData.id,
                tbUsuarios_Id: session?.usuario_Id,
                Status: rowData.status == "Ativo" ? "Aprovado" : "Reprovado",
                gerador_Id: gerador.id,
                Observacoes: justificativaReprova
            }

            setOpenModalRecusa(false)
            setJustificativaReprova("")
            setLoading(true);

            await gerador_api.PostAnaliseLocalidade(analiseLocalidade).then(response => {
                showMessage("Sucesso", `Localidade ${rowData.status == "Ativo" ? "aprovada" : "reprovada"} com sucesso!`, "success");
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })
                .finally(f => setLoading(false));
        }
    }

    const fecharModalTransportador = () => {
        setOpenModalTransportador(false);
        setRowDataAprovacao(null);
        setModalidadeSelecionada(null);
    };

    useEffect(() => {
        if (!openModalTransportador || optionsModalidades.length > 0) return;

        let ativo = true;
        modalidadeColeta_api.GetListAtivos()
            .then(response => {
                if (ativo)
                    setOptionsModalidades(response.data.map(m => ({ value: m.id, label: m.descricao })));
            })
            .catch(e => showMessage("Aviso", e.message, "error", null));

        return () => { ativo = false; };
    }, [openModalTransportador, optionsModalidades.length]);

    useEffect(() => {
        setTransportadorSelecionado(null);
        setOptionsTransportadores([]);
        if (!modalidadeSelecionada) return;

        let ativo = true;
        setCarregandoTransportadores(true);
        transportador_api.GetList(null, "Ativo", modalidadeSelecionada.value)
            .then(response => {
                if (ativo)
                    setOptionsTransportadores(response.data.map(t => ({ value: t.id, label: t.fantasia })));
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => { if (ativo) setCarregandoTransportadores(false); });

        return () => { ativo = false; };
    }, [modalidadeSelecionada]);

    async function confirmarAprovacaoComTransportador() {
        if (!rowDataAprovacao || !modalidadeSelecionada || !transportadorSelecionado) return;

        const analiseLocalidade = {
            tbGeradorLocalidades_Id: rowDataAprovacao.id,
            tbUsuarios_Id: session?.usuario_Id,
            Status: "Aprovado",
            gerador_Id: gerador.id,
            Observacoes: "",
            tbTransportadores_Id: transportadorSelecionado.value,
            tbTipoColeta_Id: modalidadeSelecionada.value
        };

        setLoading(true);
        try {
            await gerador_api.PostAnaliseLocalidade(analiseLocalidade);
        } catch (e) {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
            return;
        }

        fecharModalTransportador();
        setDadosDashboardProvider(null);
        showMessage("Sucesso", "Localidade aprovada com sucesso!", "success");

        gerador_api.GetItem(gerador.id)
            .then(response => setGerador(response.data))
            .catch(() => { })
            .finally(() => setLoading(false));
    }

    // Função para exibir o modal do histórico de análises da localidade
    const visualizarAnaliseLocalidade = (localidade_Id) => {
        setVisualizarModalAnalise(true);
        setLoading(true);

        gerador_api.GetAnaliseLocalidade(localidade_Id)
            .then(response => {
                return Promise.all(response.data.map(async m => {
                    const nomeUsuario = await usuario_api.getItem(m.tbUsuarios_Id).then(retorno => retorno.data.nome);
                    return {
                        ...m,
                        dataHora: moment(m.dataHora).format("DD/MM/YYYY HH:mm:ss"),
                        nomeUsuario: nomeUsuario
                    };
                }));
            })
            .then(dataFormatada => {
                setFichaAnaliseLocalidade(dataFormatada);
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    };

    function handleOpenModalPGRSEndereco(enderecoId) {
        const [local] = gerador.localidades.filter(x => x.id == enderecoId);
        if (!!local) {
            setListaPGRSEndereco(local?.contratosLocalidadePGRS ?? [])
            toggleModalPGRS();
        }
    }

    const [permissaoEditarGerador, setPermissaoEditarGerador] = useState()
    useEffect(() => {
        setLoading(true)
        acesso_api.getFuncionalidadesAcesso(session?.acesso?.sigla).then(response => {
            setPermissaoEditarGerador(response.data.filter(f => f.funcao == "Cadastros.Gerador")[0])
        })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    }, [])


    if (!!itemSelecionandoPGRS && !!itemSelecionandoPGRS?.pgrsGerador_Id) {
        return <FichaPGRS
            id={itemSelecionandoPGRS.pgrsGerador_Id}
            btnVoltar={() => {
                setListaPGRSEndereco([]);
                setItemSelecionandoPGRS(null)
            }}
        />
    }

    return (
        <MainCard btnVoltar={btnVoltar} >
            <div style={{ color: "#666" }}>
                <div>
                    {loading && <Loading />}
                    <ModalCustomized title={"Reprovar localidade"} isOpen={openModalRecusa} toggle={toggleModalRecusa} onClickBtnAction={() => { analisarLocalidadeConfirmation(true, rowDataRecusa) }} btnAction={<><FontAwesomeIcon className='me-3' icon={faCheck} />Confirmar reprova</>} btnActionColor={"success"} btnClose>
                        <Row>
                            <Col md="12" lg="12">
                                <TextField label={"Justificativa da reprova"} type="textarea" name={"observacao"} value={justificativaReprova} onChange={e => setJustificativaReprova(e.target.value)} invalid={!!errors.justificativaReprova} />
                            </Col>
                        </Row>
                    </ModalCustomized>

                    <ModalCustomized
                        title={"Aprovar localidade"}
                        isOpen={openModalTransportador}
                        toggle={fecharModalTransportador}
                        onClickBtnAction={confirmarAprovacaoComTransportador}
                        btnAction={<><FontAwesomeIcon className='me-3' icon={faCheck} />Confirmar aprovação</>}
                        btnActionColor={"success"}
                        disabled={!modalidadeSelecionada || !transportadorSelecionado || loading}
                        btnClose
                    >
                        <Row>
                            <Col md="12" lg="12">
                                <p>Selecione a modalidade de coleta e o transportador. Será criado um contrato pendente para o transportador ativar.</p>
                            </Col>
                            <Col md="12" lg="12">
                                <TextField
                                    name="tbTipoColeta_Id"
                                    label={"* Modalidade de coleta"}
                                    type={"select"}
                                    searchable
                                    value={modalidadeSelecionada}
                                    onChange={e => setModalidadeSelecionada(e)}
                                    options={optionsModalidades}
                                />
                            </Col>
                            <Col md="12" lg="12">
                                <TextField
                                    name="tbTransportadores_Id"
                                    label={"* Transportador"}
                                    type={"select"}
                                    searchable
                                    placeholder={carregandoTransportadores ? "Carregando..." : (modalidadeSelecionada && optionsTransportadores.length === 0 ? "Nenhum transportador atende esta modalidade" : "Selecione")}
                                    disabled={!modalidadeSelecionada || carregandoTransportadores}
                                    value={transportadorSelecionado}
                                    onChange={e => setTransportadorSelecionado(e)}
                                    options={optionsTransportadores}
                                />
                            </Col>
                        </Row>
                    </ModalCustomized>

                    <ModalCustomized
                        title={"Ficha Análise Localidade"}
                        isOpen={visualizarModalAnalise}
                        toggle={toggleModalFicaAnalise}
                        onClickBtnAction={() => { analisarLocalidadeConfirmation(true, rowDataRecusa) }}
                        btnActionColor={"success"} btnClose
                    >
                        <TabelaListagem
                            title="Histórico"
                            headers={headersTabela}
                            items={fichaAnaliseLocalidade}
                            options={{
                                print: false,
                                search: false,
                                pagination: false
                            }}
                        />
                    </ModalCustomized>

                    <ModalCustomized
                        title={"Lista de PGRS"}
                        isOpen={isOpenModalPGRS}
                        toggle={toggleModalPGRS}
                        btnClose
                    >
                        <TabelaListagem
                            headers={[
                                { value: "Identificação", objectValue: "identificacaoPGRS", align: "left" },
                                { value: "Modalidades", objectValue: "modalidadesContratosPGRSs", align: "left" }
                            ]}
                            actions={[actionsTable.visualizar((rowData) => {
                                setItemSelecionandoPGRS(rowData)
                                toggleModalPGRS();
                            })]}
                            items={listaPGRSEndereco}
                            options={{
                                print: false,
                                search: false,
                                pagination: false
                            }}
                        />
                    </ModalCustomized>

                    <h5 className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center' style={{ color: "#fff" }}> <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Identificação do gerador</span></h5>
                    <Row>
                        <Col md="12" lg="12">
                            <p><span className="fw-bold">Fantasia: </span> {gerador.fantasia}</p>
                        </Col>
                        <Col md="12" lg="12">
                            <p><span className="fw-bold">Razão social: </span> {gerador.razao}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">CPF / CNPJ: </span> {mascaras.cpfcnpjMask(gerador.cpfcnpj)}</p>
                        </Col>
                        {!!gerador?.codigoCadastro &&
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Código Cadastro: </span> {gerador.codigoCadastro}</p>
                            </Col>
                        }
                        <Col md="12" lg={4}>
                            <p><span className="fw-bold">Email: </span> {!gerador.email ? "Não informado" : gerador.email}</p>
                        </Col>
                        <Col md="12" lg={!!gerador?.codigoCadastro ? 12 : 4}>
                            <p><span className="fw-bold">Responsavel: </span> {!gerador.contato ? "Não informado" : gerador.contato}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Fone: </span> {!gerador.fone ? "Não informado" : mascaras.celularMask(gerador.fone)}</p>
                        </Col>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Celular: </span> {gerador.celular && gerador.celular.length > 0 ? gerador.celular : "Não informado"}</p>
                        </Col>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Categoria: </span> {gerador.categoria}</p>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Característica: </span> {gerador.caracteristica}</p>
                        </Col>
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Ramo de atividade: </span> {gerador.tbSegmentos_Descricao}</p>
                        </Col>
                        {gerador.dataValidade &&
                            <Col md="12" lg="4">
                                <p><span className="fw-bold">Data Validade: </span> {moment(gerador.dataValidade).format("DD/MM/YYYY")}</p>
                            </Col>
                        }
                    </Row>
                </div>
                <div>
                    <h5 style={{ color: "#fff" }} className='p-2 rounded-3 bg-gradient bg-primary fw-normal d-flex justify-content-between align-items-center'> <span><FontAwesomeIcon icon={faMapMarkerAlt} className={"me-3"} />Endereços</span>{true && <button onClick={null} style={{ backgroundColor: "transparent", border: "none", color: "#fff" }} color='info'><FontAwesomeIcon icon={faEdit} /></button>} </h5>
                    <TabelaEnderecos
                        enderecos={gerador.localidades}
                        paging={false}
                        integracaoCadastros={true}
                        analiseLocalidade={permissaoEditarGerador?.permissao == "Editar" ? analisarLocalidade : null}
                        visualizarAnaliseLocalidade={visualizarAnaliseLocalidade}
                        handleOpenModalPGRSEndereco={(enderecoId) => handleOpenModalPGRSEndereco(enderecoId)}
                    />
                </div>
                <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                    <span><FontAwesomeIcon icon={faFile} className="me-2" /> Documentos</span>
                </h5>
                <Row>
                    {gerador?.documentos.map((documento, index) => (
                        <Col lg={3} key={index} className="mb-3">
                            <div className="card shadow h-100">
                                <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                    <div className="d-flex flex-column align-items-center">
                                        <label htmlFor={`file-upload-${index}`} className="mb-3">
                                            <FontAwesomeIcon icon={faFileAlt} className="text-success" size="4x" />
                                        </label>
                                    </div>

                                    <div className="mb-3">
                                        <strong>{documento.identificacao || "Documento"}</strong>
                                    </div>

                                    <button className="btn btn-primary btn-sm mt-auto" onClick={() => {
                                        if (documento.arquivo.includes(".pdf"))
                                            window.open(documento.arquivo, "_blank")
                                        else
                                            abrirPDF(documento.arquivo);
                                    }}>
                                        <FontAwesomeIcon icon={faEye} /> Visualizar
                                    </button>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </MainCard>
    );
}